import { useEffect, useState } from "react";
import * as MUI from "@mui/material";
import yaml from "yaml";
import { Helmet } from 'react-helmet';
import RefreshIcon from '@mui/icons-material/Refresh';
import CodeIcon from '@mui/icons-material/Code';

import api from "../api";
import AccountSummary from "../components/AccountSummary";
import SubscriptionList from "../components/SubscriptionList";

export default function Dashboard() {
    const [services, setServices] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [debugMode, setDebugMode] = useState(false);

    const updateServices = async () => {
        setIsLoading(true);
        try {
            const servResp = await api.call('client/getServices');
            setServices(servResp);
        } catch (error) {
            console.error("Ошибка при получении данных:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        updateServices();
    }, []);

    const toggleDebugMode = () => {
        setDebugMode(!debugMode);
    };

    return (<>
        <Helmet>
            <title>Сводная информация</title>
        </Helmet>
        <MUI.Toolbar variant="dense">
            <MUI.Typography variant="h6" sx={{ flexGrow: 1 }}>
                Сводная информация
            </MUI.Typography>
            <MUI.Tooltip title="Обновить данные">
                <MUI.IconButton 
                    color="primary" 
                    onClick={updateServices}
                    disabled={isLoading}
                >
                    <RefreshIcon />
                </MUI.IconButton>
            </MUI.Tooltip>
            <MUI.Tooltip title={debugMode ? "Нормальный режим" : "Режим отладки"}>
                <MUI.IconButton 
                    color={debugMode ? "secondary" : "default"} 
                    onClick={toggleDebugMode}
                >
                    <CodeIcon />
                </MUI.IconButton>
            </MUI.Tooltip>
        </MUI.Toolbar>
        <MUI.Divider />
        
        {isLoading ? (
            <MUI.Box display="flex" alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
                <MUI.CircularProgress />
            </MUI.Box>
        ) : (
            <MUI.Box sx={{ p: 2 }}>
                {debugMode ? (
                    // Отладочный режим - вывод YAML
                    <pre>{yaml.stringify(services)}</pre>
                ) : (
                    // Нормальный режим - красивый интерфейс
                    services && services.accounts && services.accounts.map((account) => (
                        <MUI.Box key={account.id}>
                            <AccountSummary account={account} />
                            <SubscriptionList subscriptions={account.subscriptions} />
                        </MUI.Box>
                    ))
                )}
            </MUI.Box>
        )}
    </>);
}
